import { render, staticRenderFns } from "./SectionImageInfo.vue?vue&type=template&id=2b7d69e4&"
import script from "./SectionImageInfo.vue?vue&type=script&lang=js&"
export * from "./SectionImageInfo.vue?vue&type=script&lang=js&"
import style0 from "./SectionImageInfo.vue?vue&type=style&index=0&id=2b7d69e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrganismsCommonOrganismImageInfo: require('/app/components/organisms/common/OrganismImageInfo.vue').default})
